/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Feed } from '../models/Feed';
import type { FeedInput } from '../models/FeedInput';
import type { MainPage } from '../models/MainPage';
import type { Material } from '../models/Material';
import type { MaterialViewInput } from '../models/MaterialViewInput';
import type { MaterialViewStatus } from '../models/MaterialViewStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaterialsService {
    /**
     * Get main page
     * @returns MainPage A list of main page
     * @throws ApiError
     */
    public static getMainPage(): CancelablePromise<MainPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/main',
        });
    }
    /**
     * Get all courses
     * @returns any A list of courses
     * @throws ApiError
     */
    public static getCourses(): CancelablePromise<{
        items?: Array<Feed>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/courses',
        });
    }
    /**
     * Get all feeds
     * @returns any A list of feeds
     * @throws ApiError
     */
    public static getFeeds(): CancelablePromise<{
        items?: Array<Feed>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feeds',
        });
    }
    /**
     * Create a new feed
     * @param requestBody
     * @returns Feed Feed created
     * @throws ApiError
     */
    public static createFeeds(
        requestBody: FeedInput,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/feeds',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a feed by url
     * @param urlA
     * @returns Feed Feed found
     * @throws ApiError
     */
    public static getFeedByUrl(
        urlA: string,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feed/{url_a}',
            path: {
                'url_a': urlA,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Get a feed by ID
     * @param id
     * @returns Feed Feed found
     * @throws ApiError
     */
    public static getFeedById(
        id: string,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Update an existing feed
     * @param id
     * @param requestBody
     * @returns Feed Feed updated
     * @throws ApiError
     */
    public static updateFeedById(
        id: string,
        requestBody: FeedInput,
    ): CancelablePromise<Feed> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Delete a feed
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteFeedById(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/feeds/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Feed not found`,
            },
        });
    }
    /**
     * Получить список материалов
     * @param id
     * @returns any Список материалов
     * @throws ApiError
     */
    public static getMaterials(
        id?: string,
    ): CancelablePromise<{
        items?: Array<Material>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials',
            query: {
                'id': id,
            },
        });
    }
    /**
     * Создать материал
     * @param requestBody
     * @returns Material Материал создан
     * @throws ApiError
     */
    public static createMaterial(
        requestBody: Material,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/materials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить материал по идентификатору
     * @param urlA
     * @returns Material Материал найден
     * @throws ApiError
     */
    public static getMaterialByUrl(
        urlA: string,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/material/{url_a}',
            path: {
                'url_a': urlA,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Получить материал по идентификатору
     * @param id
     * @returns Material Материал найден
     * @throws ApiError
     */
    public static getMaterialById(
        id: string,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Обновить материал
     * @param id
     * @param requestBody
     * @returns Material Материал обновлён
     * @throws ApiError
     */
    public static updateMaterial(
        id: string,
        requestBody: Material,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Удалить материал
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteMaterials(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/materials/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Получить материал по идентификатору
     * @param id
     * @returns MaterialViewStatus Материал найден
     * @throws ApiError
     */
    public static getMaterialViewStatusById(
        id: string,
    ): CancelablePromise<MaterialViewStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/materials/{id}/view_status',
            path: {
                'id': id,
            },
            errors: {
                404: `Материал не найден`,
            },
        });
    }
    /**
     * Обновить материал
     * @param id
     * @param requestBody
     * @returns any Материал обновлён
     * @throws ApiError
     */
    public static updateMaterialViewStatus(
        id: string,
        requestBody: MaterialViewInput,
    ): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/materials/{id}/view_status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
